import { defineComponent as _defineComponent } from 'vue'
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import { PreviewTab, Tab } from '@/views/Automation/CampaignCreatorV2/types';

interface Props {
  tabs: Tab[];
  activeTab: PreviewTab;
  variant?: 'outline' | 'solid';
}

interface Emits {
  (e: 'update:active-tab', value: PreviewTab): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcPreviewTabs.ts',
  props: {
    tabs: null,
    activeTab: null,
    variant: null
  },
  emits: ["update:active-tab"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:active-tab', value: PreviewTab): void;
}), expose: any, slots: any, attrs: any }) {

const { tabs, activeTab } = __props as {
  tabs: Tab[];
  activeTab: PreviewTab;
  variant?: 'outline' | 'solid';
};





function onTabClick(id: PreviewTab) {
  emits('update:active-tab', id);
}

return { __sfc: true,emits, onTabClick, CcIcon }
}

})